/** Chaves por domínio. Um evento do tópico invalida o prefixo correspondente. */
export const queryKeys = {
  clients: {
    all: ['domain', 'clients'],
    list: (search = '') => ['domain', 'clients', 'list', search],
  },
  packages: { all: ['domain', 'packages'] },
  invoices: { all: ['domain', 'invoices'] },
  payments: { all: ['domain', 'payments'] },
  cobrancas: { all: ['domain', 'cobrancas'] },
  coletas: { all: ['domain', 'coletas'] },
  products: { all: ['domain', 'products'] },
  documents: { all: ['domain', 'documents'] },
  users: { all: ['domain', 'users'] },
  suppliers: { all: ['domain', 'suppliers'] },
  catalog: { all: ['domain', 'catalog'] },
  tracking: { all: ['domain', 'tracking'] },
  accountDeletions: { all: ['domain', 'account_deletions'] },
};

export function queryKeyForTopic(topic) {
  const name = String(topic || 'domain');
  return ['domain', name];
}
